import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { del } from "../../helpers/api_helper";
import { useNavigate, useParams } from "react-router-dom";
import { REMOVE_PARTNER_BRANCH_TIMESLOT } from "helpers/api_endpoints";

const RemovePartnerBranchTimeSlot = () => {
    const params = useParams();
    const { id } = params;
    const navigate = useNavigate();

    useEffect(() => {
        del(REMOVE_PARTNER_BRANCH_TIMESLOT, { id })
        .then(response => {
            navigate(`/partnersbranch/timeslot`, { 
                state: { 
                    successMsg: response.data?.message || 'Time slot deleted successfully' 
                } 
            });
        })
        .catch(error => {
            console.error("Error deleting time slot:", error);
            navigate(`/partnersbranch/timeslot`, { 
                state: { 
                    errorMsg: error?.response?.data?.message || 'Failed to delete time slot' 
                } 
            });
        });
    }, [id, navigate]);

    return <React.Fragment>Removing time slot...</React.Fragment>;
};

export default withRouter(RemovePartnerBranchTimeSlot);